import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { VerificationGetSMSResponseT, VerificationGetTypesResponseT } from '../types/verification.types'

export class VerificationRepository {
    sendSMS(payload: FormData): Promise<AxiosResponse<VerificationGetSMSResponseT>> {
        return http.postFormData('/verification/api/code', payload)
    }

    sendSMSRepeat(payload: FormData): Promise<AxiosResponse<VerificationGetSMSResponseT>> {
        return http.postFormData('/verification/api/code-repeat', payload)
    }

    confirm(payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/verification/api/confirm', payload)
    }

    getTypes(): Promise<AxiosResponse<VerificationGetTypesResponseT>> {
        return http.get('/cabinet/api/courier-app/verification/types')
    }
}
